import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { GestorMetrics } from '@/hooks/useGestorPerformance';
import { 
  Building2, 
  Users, 
  ClipboardCheck, 
  AlertTriangle, 
  TrendingUp,
  FileCheck,
  Clock,
  HardHat
} from 'lucide-react';

interface PerformanceSummaryCardsProps {
  totais: GestorMetrics['totais'];
}

const PerformanceSummaryCards: React.FC<PerformanceSummaryCardsProps> = ({ totais }) => {
  const cards = [
    {
      title: 'Hubs Ativos',
      value: totais.totalHubs,
      icon: Building2,
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      title: 'Profissionais',
      value: totais.totalProfissionais,
      icon: Users,
      color: 'text-secondary',
      bgColor: 'bg-secondary/10'
    },
    {
      title: 'Inspeções',
      value: `${totais.totalInspecoesConcluidas}/${totais.totalInspecoesAgendadas}`,
      subtitle: 'Concluídas/Total',
      icon: ClipboardCheck,
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      title: 'Taxa Conclusão',
      value: `${totais.taxaConclusaoGeral}%`,
      icon: TrendingUp,
      color: totais.taxaConclusaoGeral >= 70 ? 'text-success' : totais.taxaConclusaoGeral >= 50 ? 'text-warning' : 'text-destructive',
      bgColor: totais.taxaConclusaoGeral >= 70 ? 'bg-success/10' : totais.taxaConclusaoGeral >= 50 ? 'bg-warning/10' : 'bg-destructive/10'
    },
    {
      title: 'Atrasadas',
      value: totais.totalInspecoesAtrasadas,
      icon: AlertTriangle,
      color: totais.totalInspecoesAtrasadas > 0 ? 'text-destructive' : 'text-success',
      bgColor: totais.totalInspecoesAtrasadas > 0 ? 'bg-destructive/10' : 'bg-success/10'
    },
    {
      title: 'Relatórios Pendentes',
      value: totais.relatoriosPendentes,
      icon: Clock,
      color: totais.relatoriosPendentes > 0 ? 'text-warning' : 'text-success',
      bgColor: totais.relatoriosPendentes > 0 ? 'bg-warning/10' : 'bg-success/10'
    }
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
      {cards.map((card, index) => (
        <Card key={index} className="relative overflow-hidden">
          <CardContent className="p-4">
            <div className="flex items-start justify-between">
              <div>
                <p className="text-xs text-muted-foreground font-medium uppercase tracking-wide">
                  {card.title}
                </p>
                <p className={`text-xl font-bold mt-1 ${card.color}`}>
                  {card.value}
                </p>
                {card.subtitle && (
                  <p className="text-xs text-muted-foreground mt-0.5">{card.subtitle}</p>
                )}
              </div>
              <div className={`p-2 rounded-lg ${card.bgColor}`}>
                <card.icon className={`w-4 h-4 ${card.color}`} />
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default PerformanceSummaryCards;
